"use client";

import { ServerTool } from "@/components/ServerTool";
import { withExtension } from "@/lib/files";
import { getTool } from "@/lib/tools";

const tool = getTool("pdf-to-word")!;

/** PDF to Word (Phase 5, server): pdf2docx rebuilds paragraphs and tables. */
export function PdfToWordTool() {
  return (
    <ServerTool
      tool={tool}
      job="pdf-to-word"
      options={{}}
      button="Convert to Word"
      result={(file, blob) => ({
        blob,
        name: withExtension(file.name, "docx"),
      })}
    >
      <p className="text-sm text-ink">
        Text, tables and pictures come out editable, but a PDF doesn&apos;t
        store a document&apos;s structure, so the layout is close rather than
        exact — check it before you send it on. Scanned pages come out as
        pictures (the text in them isn&apos;t read).
      </p>
    </ServerTool>
  );
}
